
import './components/kdl/KdlApp.css';
import KdlApp from './components/kdl/KdlApp';
import 'bootstrap/dist/css/bootstrap.min.css';


// Add this anywhere in your React app temporarily
console.log('App.js :');
console.log('Environment:', process.env.NODE_ENV);
console.log('API Base URL:', process.env.REACT_APP_API_BASE_URL);


function App() {
  return (
    <div className="App">
      <KdlApp />
    </div>
  )
}


export default App;
